import { render, staticRenderFns } from "./plotTree.vue.html?vue&type=template&id=efa74c6a&lang=html&external"
import script from "./plotTree.vue.js?vue&type=script&lang=js&external"
export * from "./plotTree.vue.js?vue&type=script&lang=js&external"
import style0 from "./PlotItem.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports